import { Auth } from 'aws-amplify';
import config from './config';

/** Get the current Cognito ID token (JWT) for Authorization headers. */
async function authHeader() {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return { Authorization: token };
}

async function request(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(await authHeader()),
    ...(options.headers || {})
  };
  const res = await fetch(`${config.apiBase}${path}`, { ...options, headers });
  const text = await res.text();
  const body = text ? JSON.parse(text) : {};
  if (!res.ok) {
    const err = new Error(body.error || `Request failed (${res.status})`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export const api = {
  listFarms: () => request('/farms'),
  triggerRun: (farm, scenario) =>
    request('/run', {
      method: 'POST',
      body: JSON.stringify({ farm, ...(scenario || {}) })
    }),
  listGccScenarios: (farm) =>
    request(`/scenarios?farm=${encodeURIComponent(farm)}`),
  getRun: (farm, runId) =>
    request(`/run/${encodeURIComponent(runId)}?farm=${encodeURIComponent(farm)}`),
  listRuns: (farm, limit = 25) =>
    request(`/runs?farm=${encodeURIComponent(farm)}&limit=${limit}`),
  listAdminFarms: () => request('/admin/farms'),
  createFarm: (payload) =>
    request('/admin/farms', { method: 'POST', body: JSON.stringify(payload) }),
  updateFarm: (code, payload) =>
    request(`/admin/farms/${encodeURIComponent(code)}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    }),
  disableFarm: (code) =>
    request(`/admin/farms/${encodeURIComponent(code)}`, { method: 'DELETE' }),
  enableFarm: (code) =>
    request(`/admin/farms/${encodeURIComponent(code)}/enable`, { method: 'POST' }),
  deleteFarmPermanent: (code) =>
    request(`/admin/farms/${encodeURIComponent(code)}/permanent`, { method: 'DELETE' })
};

export default api;
